import Experience from "./Experience/Experience";
import Projects from "./Projects/Projects";
import Skills from "./Skills/Skills";
import Resume from "./Resume";
import Education from "./Education";
import ScrollToTop from "./ScrollToTop";

const Home = () => {
    return (
        <div>
            <ScrollToTop>
                <Resume />
            </ScrollToTop>
            <Projects />
            <Skills />
            <Experience />
            <Education />
        </div>
    );
}

export default Home;
